// @flow
import { onUpdateUserLayers } from 'catena/er2_map_userlayers/js/actions/map'
import type { WindowStateType } from 'catena/er2_map_userlayers/js/components/window_state'
import * as types from '../constants/action_types'

export const onRefugeeModelDisplayStatistics = () => ({ type: types.REFUGEE_MODEL_DISPLAY_STATISTICS })
export const setRefugeeModelWindowState = (windowState: WindowStateType) => ({ type: types.REFUGEE_MODEL_WINDOW_STATE, windowState })

export const updateRefugeeLayer = (grid: string) => ({ type: types.UPDATE_REFUGEE_GRID, grid })

/**
 * Create ascii grid for digpop model from current theme and user-traced polygon
 */
export const generateGridFromPoly = (affected: string, combat: string) => (dispatch: Function, getState: Function) => {
    let fetchError = false
    const ficusNode = getState().selectFrameworkBar.ficusNode
    const iInterval = getState().analyzeFrameworkBar.iInterval
    const interval = getState().selectFrameworkBar.ficusData.intervals[iInterval]
    const token = getState().token.value

    fetch(`/${getState().meta.name}/generateGrid/?token=${token}`, {
        body: JSON.stringify({
            affected, combat, ficusNode, interval,
        }),
        method: 'POST',
    }).then((response) => {
        fetchError = !response.ok
        return response.json()
    }).then((json) => {
        if (fetchError) {
            alert(json.exception.message)
        } else {
            dispatch(updateRefugeeLayer(json.grid))
            dispatch(onUpdateUserLayers())
        }
    })
}
